(() => {
  const SKIP_SELECTORS = ['header', '.header', '.shopify-section--header'];

  function shouldSkip(element) {
    if (!element) return false;
    if (element.dataset.lazyExclude === 'true') return true;
    return SKIP_SELECTORS.some((selector) => element.closest(selector));
  }

  function applyLazyAttributes() {
    const imageCandidates = document.querySelectorAll('img:not([loading]), img[loading="auto"]');
    imageCandidates.forEach((image) => {
      if (shouldSkip(image)) return;
      image.loading = 'lazy';
      image.decoding = 'async';
      if (!image.hasAttribute('fetchpriority') && image.dataset.fetchpriority) {
        image.setAttribute('fetchpriority', image.dataset.fetchpriority);
      }
    });

    const iframeCandidates = document.querySelectorAll('iframe:not([loading]), iframe[loading="auto"]');
    iframeCandidates.forEach((frame) => {
      if (shouldSkip(frame)) return;
      frame.loading = 'lazy';
    });

    const videoCandidates = document.querySelectorAll('video[preload="auto"]:not([data-keep-preload])');
    videoCandidates.forEach((video) => {
      if (shouldSkip(video)) return;
      if (!video.autoplay) {
        video.preload = 'metadata';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLazyAttributes, { once: true });
  } else {
    applyLazyAttributes();
  }
})();
